import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
let IllegalManagementApi = class IllegalManagementApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        /**
        * 查询违规IP列表
        **/
        this.getCarsiSuspectSellIPList = (params) => {
            return this.http.get({
                url: this.urls.getCarsiSuspectSellIPList,
                params: {
                    ...params,
                },
            });
        };
        /**
        * 新增违规IP
        **/
        this.postAddCarsiSuspectSellIP = (params) => {
            return this.http.post({
                url: this.urls.postAddCarsiSuspectSellIP,
                data: params,
            });
        };
        /**
        *  查询违规公司列表
        **/
        this.getCarsiSuspectSellTenantList = (params) => {
            return this.http.get({
                url: this.urls.getCarsiSuspectSellTenantList,
                params: {
                    ...params,
                },
            });
        };
        /**
        * 新增违规公司
        **/
        this.postAddCarsiSuspectSellTenant = (params) => {
            return this.http.post({
                url: this.urls.postAddCarsiSuspectSellTenant,
                data: params,
            });
        };
        /**
        * 查询违规用户列表
        **/
        this.getCarsiSuspectSellUserList = (params) => {
            return this.http.get({
                url: this.urls.getCarsiSuspectSellUserList,
                params: {
                    ...params,
                },
            });
        };
    }
    /**
    * 删除违规IP
    **/
    deleteCarsiSuspectSellIP(ip) {
        const url = format(this.urls.deleteCarsiSuspectSellIP, { ip });
        return this.http.delete({
            url,
        });
    }
    /**
    * 删除违规公司
    **/
    deleteCarsiSuspectSellTenant(tenant_id) {
        const url = format(this.urls.deleteCarsiSuspectSellTenant, { tenant_id });
        return this.http.delete({
            url,
        });
    }
    /**
    * 删除违规用户
    **/
    deleteCarsiSuspectSellUser(tenant_user_id, remove_remark) {
        const url = format(this.urls.deleteCarsiSuspectSellUser, { tenant_user_id });
        return this.http.delete({
            url,
            params: {
                remove_remark,
            },
        });
    }
    /**
    * 编辑黑名单公司列表
    **/
    editCarsiSuspectSellUser(params) {
        return this.http.post({
            url: this.urls.editCarsiSuspectSellTenant,
            data: params,
        });
    }
};
IllegalManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.IllegalManagementUrls)),
    __metadata("design:paramtypes", [Object, Object])
], IllegalManagementApi);
export { IllegalManagementApi };
